import React from "react";

const CustomLayout = function ({
    header,
    contentSiblings,
    children,
    className = "",
    classNameHeader = "",
    classNameBody = "",
    style
}) {
    return (
        <div style={style} className={`custom-layout d-flex-col ${className}`}>
            {header && (
                <div className={`custom-layout-header d-flex gap-1 ${classNameHeader}`}>
                    {header}
                </div>
            )}
            <div className={`custom-layout-body d-flex flex-1 ${classNameBody}`}>
                {children}
            </div>
            {contentSiblings}
        </div>
    );
};

export default CustomLayout;
